<template>
  <base-modal-center
    :isFooter="true"
    ref="shareQRCodeModal"
    title="Compartilhe seu site"
  >
    <template #btn-close-icon>
      <i class="icon">
        <base-icon name="painel/close-icon" />
      </i>
    </template>
    <div class="modal-share-wedsite has-text-centered">
      <h6 class="c-base-modal__title">QR Code do seu site</h6>
      <div class="intro-text-label">
        Faça o download do seu QR Code exclusivo e compartilhe o seu site com
        seus convidados.
      </div>
      <div class="convite-label">
        Você também poderá utilizá-lo em seu convite ;)
      </div>
      <div class="group-qrcode">
        <a :href="qrCodeUrl + '?download=1'">
          <div class="qr-code">
            <img width="108" :src="qrCodeUrl" />
          </div>

          <button class="button button-qrcode">
            <i class="fa fa-download" style="margin-right: 6px"></i>
            Baixar QR Code
          </button>
        </a>
      </div>

      <div class="link-box-text">
        <div class="link-box-text-title">Este é o link do seu site</div>
        <div id="link-url" class="link-box-text-url">
          {{ this.siteUrl }}
        </div>

        <div class="copy-link">
          <img id="image-copy" src="~@/assets/img/copy.svg" />
          <div class="copy-link-text" @click="copyToClipboard()">
            Copiar Link
          </div>
        </div>
      </div>
    </div>
  </base-modal-center>
</template>

<script>
import isMobileBrowser from '@/plugins/detect-mobile-browser'
import BaseModalCenter from '@/components/BaseModalCenter.vue'

const BASE_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  components: {
    BaseModalCenter,
  },

  data() {
    return {
      modalOpened: false,
      message: `Olá, está chegando o momento mais esperado do ano! O nosso casamento :heart: Estamos muito felizes e contamos com a sua presença no nosso grande dia!\n\nPara facilitar na organização do nosso casamento, criamos um site onde compartilhamos com você todos os detalhes do nosso evento.\n\nÉ muito importante que você confirme a sua presença. Para isto, basta clicar no menu “Confirme sua Presença” e preencher os dados necessários.\n\nPara nos presentear, você pode escolher qualquer item da nossa Lista de Presentes :blush:\n\nAguardamos você no nosso grande dia!`,
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    baseUrl() {
      return BASE_URL
    },

    siteUrl() {
      return this.wedSiteInfo?.shared_menu?.wedsite_url_for_guests.replace(
        /^https?:\/\//,
        ''
      )
    },

    qrCodeUrl() {
      return (
        this.baseUrl + '/qrcodeImage/' + this.logonToken?.token_payload?.wed_id
      )
    },

    whatsAppLink() {
      let linkToShare = `Clique no link abaixo e acesse nosso site:\n${this.wedSiteInfo.shared_menu.wedsite_url_for_guests}`

      let linkWP = isMobileBrowser()
        ? 'whatsapp://'
        : 'https://web.whatsapp.com/'
      linkWP += 'send?text='

      if (this.message.length) {
        return (
          linkWP +
          window.encodeURIComponent(`${this.message}\n\n${linkToShare}`)
        )
      }
      return linkWP + window.encodeURIComponent(linkToShare)
    },
  },

  methods: {
    open() {
      this.$refs.shareQRCodeModal.open()
      this.modalOpened = true
    },

    close() {
      this.$refs.shareQRCodeModal.close()
      this.modalOpened = false
    },
    copyToClipboard() {
      this.$copyText(this.wedSiteInfo.shared_menu.wedsite_url_for_guests)
      document.getElementsByClassName('copy-link-text')[0].innerHTML =
        'Link copiado'
      document.getElementsByClassName('copy-link-text')[0].style.color =
        '#3DAFB0'
      document.getElementById('image-copy').classList.add('filtered-img')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-body {
  padding-left: 0px;
  padding-right: 0px;
}

.filtered-img {
  content: url('~@/assets/img/copied.svg');
  width: 24px;
}

.group-qrcode {
  display: block;
}
.is-primary {
  color: $primary !important;
  background-color: transparent !important;
}
.copy-link {
  color: $primary;
  font-weight: 700;
  font-size: 18px;
  margin-top: 16px;
  display: inline-flex;
  cursor: pointer;
}

.copy-link img {
  margin-right: 19px;
}

.link-box-text {
  background-color: #f0f5fa;
  width: 504px;
  height: 145px;
  margin-top: 24px;
  text-align: center;
  display: inline-block;
  border-radius: 16px;
}

.link-box-text-title {
  color: $neutral;
  font-size: 18px;
  font-weight: 700;
  margin-top: 24px;
}

.link-box-text-url {
  margin-top: 12px;
}

.intro-text-label {
  color: $neutral;
  font-weight: 400;
  margin-top: 24px;
  font-size: 18px;
}
.convite-label {
  margin-top: 24px;
  font-weight: 700;
  font-size: 18px;
  color: $primary;
}

.qr-code {
  margin-top: 24px;
}

.button-qrcode {
  border: solid 2px $primary;
  width: 208px !important;
  height: 48px !important;
  color: $primary !important;
  margin-top: 24px;
  border-radius: 100px;
  text-align: center;
}

.button-qrcode:hover {
  border: solid 2px $primary;
  width: 208px;
  color: #ffff !important;
  background-color: $primary;
}

@media (max-width: 768px) {
  .link-box-text {
    width: 264px;
    height: 164px;
  }

  .link-box-text-title {
    margin-top: 24px;
  }

  .copy-link {
    margin-top: 20px;
  }
}

@media (max-height: 620px) {
  .c-base-modal {
    height: 650px;
  }

  .intro-text-label {
    font-size: 16px;
  }

  .convite-label {
    font-size: 17px;
  }
  .link-box-text {
    height: 130px;
  }

  .copy-link {
    margin-top: 12px;
  }

  .link-box-text-title {
    font-size: 16px;
  }
}
</style>
